import { components } from "../api/generated/generated-api";

// Type aliases for generated enums
export type Category = components["schemas"]["Category"];
export type TransactionType = components["schemas"]["TransactionType"];
export type Method = components["schemas"]["Method"];

/**
 * Convert enum category values to display labels
 */
export const getCategoryDisplayName = (category: Category): string => {
    switch (category) {
        case "Goods":
            return "Goods";
        case "Services":
            return "Services";
        case "IP":
            return "IP";
        default:
            return category;
    }
};

/**
 * Convert enum transaction type values to display labels
 */
export const getTransactionTypeDisplayName = (type: TransactionType): string => {
    switch (type) {
        case "Manufacturing":
            return "Manufacturing";
        case "Distribution":
            return "Distribution";
        case "Procurement":
            return "Procurement";
        case "ResearchAndDevelopment":
            return "Research and Development";
        case "Engineering":
            return "Engineering";
        case "SalesAndMarketing":
            return "Sales and Marketing";
        case "ManagementAndAdministrativeSupport":
            return "Management and Administrative Support";
        case "StrategicManagement":
            return "Strategic Management";
        case "ITTechnology":
            return "IT / Technology";
        case "SoftwareDevelopment":
            return "Software Development";
        case "ProductTechnology":
            return "Product / Technology";
        case "BrandTrademark":
            return "Brand / Trademark";
        case "KnowledgeProcesses":
            return "Knowledge / Processes";
        case "Other":
            return "Other";
        default:
            return type;
    }
};

/**
 * Convert enum method values to display labels
 */
export const getMethodDisplayName = (method: Method): string => {
    switch (method) {
        case "CUP":
            return "Comparable Uncontrolled Price Method";
        case "ResaleMargin":
            return "Resale Margin";
        case "CostPlus":
            return "Cost Plus";
        case "CPM":
            return "Comparable Profits Method";
        case "ProfitSplit":
            return "Profit Split";
        case "CUSP":
            return "Comparable Uncontrolled Service Price Method";
        case "GrossServicesMargin":
            return "Gross Services Margin";
        case "CostOfServicesPlus":
            return "Cost of Services Plus";
        case "SCM":
            return "SCM";
        case "CUT":
            return "CUT";
        case "Unspecified":
            return "Unspecified";
        default:
            return method;
    }
};

// Generate options from enums
export const CATEGORY_OPTIONS: Category[] = ["Goods", "Services", "IP"];

export const TRANSACTION_TYPE_OPTIONS: Record<Category, TransactionType[]> = {
    Goods: ["Manufacturing", "Distribution", "Procurement"],
    Services: [
        "ResearchAndDevelopment",
        "Engineering",
        "SalesAndMarketing",
        "ManagementAndAdministrativeSupport",
        "StrategicManagement",
        "ITTechnology",
        "SoftwareDevelopment",
        "Other",
    ],
    IP: ["ProductTechnology", "BrandTrademark", "KnowledgeProcesses", "Other"],
};

export const METHOD_OPTIONS: Record<Category, Method[]> = {
    Goods: ["CUP", "ResaleMargin", "CostPlus", "CPM", "ProfitSplit", "Unspecified"],
    Services: ["CUSP", "GrossServicesMargin", "CostOfServicesPlus", "CPM", "ProfitSplit", "SCM"],
    IP: ["CUT", "CPM", "ProfitSplit", "Unspecified"],
};
